// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MetricsReportPage .row {
    margin-left: 0;
    margin-right: 0;
}

.MetricsReportPage .container, .container-fluid {
    display: flex;
    flex-direction: column;
}

.MetricsReportPage .table td {
    vertical-align: middle;
    padding: 0.5rem;
}

.MetricsReportPage .table {
    word-wrap: break-word;
    table-layout: fixed;
}

.error-icon {
    background-image: url('https://s3.ap-southeast-2.amazonaws.com/assets.eevi.life/alarms_dashboard/assets/images/icon-alert.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
}

.success-icon {
    background-image: url('https://s3.ap-southeast-2.amazonaws.com/assets.eevi.life/alarms_dashboard/assets/images/icon-taken.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,+HAA+H;IAC/H,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,+HAA+H;IAC/H,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;AACzB","sourcesContent":[".MetricsReportPage .row {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.MetricsReportPage .container, .container-fluid {\n    display: flex;\n    flex-direction: column;\n}\n\n.MetricsReportPage .table td {\n    vertical-align: middle;\n    padding: 0.5rem;\n}\n\n.MetricsReportPage .table {\n    word-wrap: break-word;\n    table-layout: fixed;\n}\n\n.error-icon {\n    background-image: url('https://s3.ap-southeast-2.amazonaws.com/assets.eevi.life/alarms_dashboard/assets/images/icon-alert.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px;\n}\n\n.success-icon {\n    background-image: url('https://s3.ap-southeast-2.amazonaws.com/assets.eevi.life/alarms_dashboard/assets/images/icon-taken.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
